<template>
  <div v-if="creditMessages">
    <span
      class="layout--flex-align-center layout--flex-center layout--margin-bottom-sm"
    >
      <IconExclamation class="dashboard__icon dashboard__icon--blue" />
      <strong>{{ creditMessages.alert }}</strong>
    </span>
    <p class="layout--text-center layout--margin-bottom-md">
      {{ creditMessages.description }}
    </p>
    <router-link
      v-if="this.subscription.discriminator !== 'Enterprise'"
      :to="{ name: 'change plan' }"
      class="button button--secondary button--wide"
      >Upgrade</router-link
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { subscriptionTypeEnums } from "../../../../helpers/helpers";

import IconExclamation from "../../../../assets/icons/iconAlertBar-Exclamation.svg";

export default {
  name: "credit-message",
  components: { IconExclamation },
  computed: {
    ...mapGetters("account", ["account", "subscription", "subscriptionOption"]),
    costPerCredit: function() {
      const subOption = this.subscriptionOption(
        this.subscription.subscriptionType
      );

      if (!subOption) return null;
      return subOption.costPerCredit;
    },
    subscriptionName() {
      return subscriptionTypeEnums.find(
        sub => sub.enum === this.subscription.subscriptionType
      ).description;
    },
    isEarlyBird() {
      return this.subscription.subscriptionType === 1;
    },
    isVip() {
      return this.subscription.subscriptionType === 2;
    },
    creditMessages: function() {
      if (this.costPerCredit === null || this.isEarlyBird || this.isVip) {
        return false;
      }
      if (this.account.credits < 500 && this.account.credits > 0) {
        return { alert: "Credits are running low", description: "" };
      }
      if (this.account.credits <= 0 && this.costPerCredit === 0) {
        return {
          alert: "Out of monthly credits",
          description:
            "Your timers will no longer appear within your emails. Upgrade plan?",
        };
      }
      if (this.account.credits <= 0 && this.costPerCredit > 0) {
        let msg = {
          alert: "Out of monthly credits",
          description: `Cost of additional impressions is $${this.costPerCredit}`,
        };

        switch (this.subscriptionName) {
          case "Bootstrap":
            msg.alert = "All monthly credits used";
            msg.description = `For the remainder of your billing period you will be charged $${this.costPerCredit} for each impression used`;
            break;
          case "Startup":
          case "Enterprise":
            msg.alert = "All available credits have been used";
            msg.description = `For the remainder of your billing period you will be charged $${this.costPerCredit} for each impression used`;
            break;
        }

        return msg;
      }
      return false;
    },
  },
};
</script>

<style></style>
